import classNames from 'classnames';
import { Button } from 'fasoo-ui-component-next';
import { useTranslation } from 'react-i18next';
import { findApprovalTypeIcon } from 'src/pages/users/approval/pending/ApprovalPendingList';

import './index.scss';

export interface ApprovalDetailFooterProps {
  approvalMethod: string;
  handleReject: () => void;
  handleApprove: () => void;
}

export const ApprovalDetailFooter: React.FC<ApprovalDetailFooterProps> = ({
  approvalMethod,
  handleReject,
  handleApprove,
}) => {
  const { t } = useTranslation(['userApproval']);
  return (
    <div className="detail-footer">
      <Button
        height={52}
        classes={classNames('reject-button', { hidden: approvalMethod === 'POST' })}
        text={t('userApproval:remarkPopup.reject.rejectOk')}
        color="error"
        onClick={handleReject}
      />
      <Button
        height={52}
        classes="approve-button"
        text={t('userApproval:remarkPopup.approval.approveOk')}
        onClick={handleApprove}
      />
    </div>
  );
};
